module.exports = __webpack_public_path__ + "img/76.255d4d50.jpg";